const Color = {

    // FIELDS
    "name": "Name",
    "color_code": 'Color Code',
    "search": "Search",

    // PAGE HEADER
    "color": "Color",

    // ERROR
    "error_name": "Enter Name",
    "error_color": "Enter Color Code",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_color": "COLOR CODE",
}

export default Color;